<template>
  <div v-if="filterThird" class="card card-material card-thickness">
    <div class="card-body pb-0 card-material" :class="{ 'active': isActive }">
      <div @click="openFilter()" class="card-title card-material-title" :class="{ 'clear-select': thickness }">
        {{ filterTitle }}
        <div v-if="thickness" class="badge badge-selected float-right">{{ selectedName }}</div>
        <font-awesome-icon v-if="showFilter && thickness" class="font-awesome-icon action angle-up hidefilter" v-on:click.stop.prevent="hideFilter" icon="angle-up"/>
      </div>

      <div v-if="showFilter" class="select-type">
        <div class="form-group">
          <v-select placeholder="Dikte" v-model="thickness" :options="thicknesses" v-on:click.stop.prevent="click()" ref="dropdown"></v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { MUTATE_PRODUCT, MUTATE_CODE, MUTATE_THICKNESS, SET_MATERIAL_THICKNESS, SET_DISABLE_PANEL_INPUT } from '../../../store/types'
  import { EventBus } from '../../../bus'

  export default {
    data() {
      return {
        showFilter: false
      }
    },
    computed: {
      filterThird() {
        return this.$store.getters.filterThird
      },
      isActive() {
        return this.showFilter || (!this.filterSecond && !this.$store.getters.materialThickness)
      },
      filterTitle() {
        return this.$store.getters.filterFirst.indexOf('HPL') !== -1 ? 'Dikte kernmateriaal' : 'Dikte materiaal'
      },
      products() {
        return this.$store.getters.products
      },
      thicknesses() {
        if (this.$store.getters.filterThird) {
          let filterDeliveryProgram = this.$store.getters.filterDeliveryProgram
          let filterFirst = this.$store.getters.filterFirst
          let filterSecond = this.$store.getters.filterSecond
          let filterThird = this.$store.getters.filterThird !== 'geen' ? this.$store.getters.filterThird : ''

          let products = this.products.filter((product) => (product.deliveryprogram === filterDeliveryProgram && product.filter_1 === filterFirst && product.filter_2 === filterSecond && product.filter_3 === filterThird))

          // Sort by thickness
          let filters = [...new Set(products.sort((a, b) => (parseInt(a.thickness) > parseInt(b.thickness)) ? 1 : ((parseInt(b.thickness) > parseInt(a.thickness)) ? -1 : 0)))]

          if (this.$store.getters.filterDeliveryProgram === 'Meubelpanelen') {
            // Filter uniques, let Pombase pick the correct product!
            filters = filters.reduce((unique, item) => {
              return unique.findIndex(u => u.thickness === item.thickness) < 0 ? [...unique, item] : [...unique]
            }, [])
          }

          // If only 1 option is left, just pre-select the item, and move on
          if (filters.length === 1) {
            this.select(filters[0])
          }

          // Return thicknesses and add the code & label for the select input
          return filters.map(filter => {
            filter.code = filter.thickness
            filter.label = filter.thickness + ' mm'

            return filter
          })
        }

        return []
      },
      thickness: {
        get() {
          return !this.$store.getters.materialThickness ? false : this.$store.getters.materialThickness
        },
        set(value) {
          if (value !== this.thickness) {
            let product = value === null ? null : value
            let code = value === null ? null : value.id
            let thickness = value === null ? null : value.thickness

            this.$store.commit(MUTATE_PRODUCT, product) // Store the product, we need it on the confirm order page when page is reloaded...
            this.$store.commit(MUTATE_CODE, code) // Store the product id, it is used by pombase
            this.$store.commit(MUTATE_THICKNESS, thickness)

            if (this.$store.getters.filterFirst.indexOf('HPL') === -1) {
              // In case of HPL, only reset finish when changing side1
              EventBus.$emit('reset-finish-selection')
            }
            
            // Validate the rows, if thickness has changed
            setTimeout(function() {
              EventBus.$emit('validate-row')
            }, 1000)
          }
          this.showFilter = false

          this.$store.dispatch(SET_DISABLE_PANEL_INPUT)
        }
      },
      selectedName() {
        if (this.thickness) {
          return this.thickness + ' mm'
        }

        return ''
      }
    },
    watch: {
      selected: function(newValue) {
        // Update the material thickness
        this.$store.dispatch(SET_MATERIAL_THICKNESS, newValue)
      }
    },
    methods: {
      select(select) {
        if (select !== this.thickness) {
          this.thickness = select
        }
        if (select) {
          this.showFilter = false
        }
      },
      openFilter() {
        if (this.thickness && this.showFilter) {
          this.showFilter = false
        } else {
          this.showFilter = true
        }
      },
      hideFilter() {
        if (this.thickness) {
          this.showFilter = false
        }
      }
    },
    updated() {
      this.showFilter = (this.$store.getters.loadingMaterial) ? false : (!this.thickness) ? true : this.showFilter
    },
    created() {
      this.showFilter = !this.thickness
    }
  }
</script>

<style lang="scss" scoped>
  .card-title {
    font-weight: bold;
  }

  .card-type {
    text-align: center;
    font-weight: bold;
  }
</style>
